module.exports = __webpack_public_path__ + "img/MobileDisabledFeedbackPoor.692ff596.png";